import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { TranslateVideoInputDto } from './model';

const videoTranslationAtom = atomWithStorage<Partial<TranslateVideoInputDto>>(
  'video_translation_page_data_v7',
  {},
  void 0,
  {
    getOnInit: true,
  },
);

export function useVideoTranslationPageData() {
  return useAtom(videoTranslationAtom);
}
